import Global from '@icons/Global.svg';
import { useTranslation } from 'react-i18next';
import { STORAGE_KEYS } from '../../constants';
import { SUPPORTED_LOCALES } from '../../translations/i18n';
import { Dropdown } from '../../ui-library/Patterns/Inputs/Dropdown';
import { setOsanoLocale } from '../../utils/osano';
import { setLocalStorageItem } from '../../utils/storage';

export const LanguageSelector = ({ direction }: { direction: 'up' | 'down' }) => {
  const { t, i18n } = useTranslation('common', { keyPrefix: 'common' });

  const onLanguageChange = (value: string) => {
    if (value !== i18n.language) {
      void i18n.changeLanguage(value);
      setLocalStorageItem(STORAGE_KEYS.LANGUAGE, value);
      setOsanoLocale(value);
    }
  };

  const options = SUPPORTED_LOCALES.map((lang) => ({ label: t(`countries.iso-to-name.${lang}`), value: lang }));

  return (
    <Dropdown
      name='language'
      selectedValues={i18n.language}
      onChange={onLanguageChange}
      options={options}
      placeholder={t('common.language-selector.placeholder')}
      type='single'
      direction={direction}
      icon={Global}
      className='w-[11.5rem]'
    />
  );
};
